interface SuitcaseIconStaticProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const SuitcaseIconStatic = ({
  width = 20,
  height = 20,
  className,
  color = 'currentColor',
  strokeWidth = 1.64
}: SuitcaseIconStaticProps) => {
  // Normal state values (same as animated icon's normal state)
  const normalTopCurve = "M0.820312 5.82007C0.820312 4.7155 1.71574 3.82007 2.82031 3.82007H17.1803C18.2849 3.82007 19.1803 4.7155 19.1803 5.82007V17.1801C19.1803 18.2846 18.2849 19.1801 17.1803 19.1801H2.82031C1.71574 19.1801 0.820312 18.2846 0.820312 17.1801V5.82007Z";
  const normalMiddleCurve = "M6.41031 12.1801H2.82031C1.71574 12.1801 0.820312 11.2846 0.820312 10.1801V5.82007C0.820312 4.7155 1.71574 3.82007 2.82031 3.82007H17.1803C18.2849 3.82007 19.1803 4.7155 19.1803 5.82007V10.1801C19.1803 11.2846 18.2849 12.1801 17.1803 12.1801H13.5903";
  const normalHandle = "M13.1803 3.18007V1.82007C13.1803 1.26778 12.7326 0.820068 12.1803 0.820068H7.82031C7.26803 0.820068 6.82031 1.26778 6.82031 1.82007V3.18007";
  const normalBottomSquare = "M6.82387 11.5297C6.82472 10.978 7.27219 10.5312 7.82387 10.5312H12.1839C12.7368 10.5312 13.1847 10.9799 13.1839 11.5328L13.1819 12.8296C13.181 13.3813 12.7335 13.8281 12.1819 13.8281H7.82186C7.26897 13.8281 6.82101 13.3794 6.82186 12.8265L6.82387 11.5297Z";

  return (
    <div className={className} style={{ width, height }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={normalTopCurve}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
        />

        <path
          d={normalMiddleCurve}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
        />

        <path
          d={normalHandle}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
        />

        <path
          d={normalBottomSquare}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
        />
      </svg>
    </div>
  );
}; 